import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import ImgUrl from 'assets/images/global.png';
import ImgWorldMap from 'assets/images/worldmap.png'
import {pageMenuTabList03} from 'types/common';

import 'assets/css/brand.scss';

import { fnSetTimeTab } from 'assets/js/commonUtil';

function Global() {
  const globalProp = [
    { id: "베트남", status: false, text: "" },
    { id: "미국", status: false, text: "" },
    { id: "중국", status: false, text: "" },
    { id: "호주", status: false, text: "" },
    { id: "말레이시아", status: false, text: "" },
    { id: "싱가폴", status: false, text: "" },
  ];

    
  const { brandId } = useParams<{ brandId: string }>();
  
  pageMenuTabList03[0].on = true;
  
  const [map, setMap] = useState(globalProp);
  
  const ItemHandler = (e: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLImageElement>, idx: number) => {
    console.log(`ItemHandler: idx=${idx}`);
    const newList = [...map];
        
    
    for (let i = 0; i < globalProp.length; i++) {
      newList[i].status = false;      
    }

    newList[idx].status = true;
    setMap(newList);

    
    console.log(newList);

  };
  useEffect(() => {  
    
    fnSetTimeTab();

  }, []);

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/global-hero_1920x1080.jpg.jpg" imgText="해외사업현황" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList03}></PageTab>
          
      <div className="business container">
        <div className="page-inner-tab">
          <div className="tabs">
            <div className="tab on">전체</div>
            <div className="tab">베트남</div>
            <div className="tab">미국</div>
            <div className="tab">중국</div>
            <div className="tab">호주</div>
            <div className="tab">말레이시아</div>
            <div className="tab">싱가폴</div>
          </div>
        </div>

        <div className="page-inner-tab">
          <div className="tab-list on">
            <div className="gobal-map view-all">
              <img className="globalmap" src="https://img.chunhomall.com/images/brand_site/map-all_img_1240x650.jpg.jpg" style={{width:"100%"}} alt=""></img>
            </div>
            
          </div>
          <div className="tab-list">
            <div className="gobal-map">
              <img className="globalmap" src="https://img.chunhomall.com/images/brand_site/map-Vietnam_img_1240x650.jpg.jpg" style={{width:"100%"}} alt=""></img>              
            </div>
            <div className="map-info">
              <img className="map-info-img" src="https://img.chunhomall.com/images/brand_site/map-section-02_400x400.jpg.jpg" alt=""></img>
              <div className="map-info-text">
                <div className="map-info-title">베트남</div>
                <div className="map-info-content">40여 개 전문매장 보유, 키즈부터 중장년층까지 천호엔케어의 다양한 제품을 선보이고 있습니다.</div>
              </div>
              
            </div>
          </div>
          <div className="tab-list">
            <div className="gobal-map">
              <img className="globalmap" src="https://img.chunhomall.com/images/brand_site/map-usa_img_1240x650.jpg.jpg" style={{width:"100%"}} alt=""></img>              
            </div>
            <div className="map-info">
              <img className="map-info-img" src="https://img.chunhomall.com/images/brand_site/map-section-01_400x400.jpg.jpg" alt=""></img>
              <div className="map-info-text">
                <div className="map-info-title">미국</div>
                <div className="map-info-content">오프라인 매장(LA, 하와이), 온라인, 홈쇼핑 등에서 만나 실 수 있습니다.</div>
              </div>
            </div>
          </div>
          <div className="tab-list">
            <div className="gobal-map">
              <img className="globalmap" src="https://img.chunhomall.com/images/brand_site/map-China_img_1240x650.jpg.jpg" style={{width:"100%"}} alt=""></img>              
            </div>
            <div className="map-info">
              <img className="map-info-img" src="https://img.chunhomall.com/images/brand_site/map-section-04_400x400.jpg.jpg" alt=""></img>
              <div className="map-info-text">
                <div className="map-info-title">중국</div>
                <div className="map-info-content">티몰 국제, 틱톡 플래그쉽 스토어를 운영하고 현지 SNS와 왕홍을 통해 맞춤 제품을 판매하고 있습니다.</div>
              </div>
            </div>
          </div>
          <div className="tab-list">
            <div className="gobal-map">
              <img className="globalmap" src="https://img.chunhomall.com/images/brand_site/map-Australia_img_1240x650.jpg.jpg" style={{width:"100%"}} alt=""></img>              
            </div>
            <div className="map-info">
              <img className="map-info-img" src="https://img.chunhomall.com/images/brand_site/map-section-05_400x400.jpg.jpg" alt=""></img>
              <div className="map-info-text">
                <div className="map-info-title">호주</div>
                <div className="map-info-content">2014년부터 호주 내 전 지역 아시안 마트에서 판매, 온라인으로도 만나볼 수 있습니다.</div>
              </div>
              
            </div>
          </div>
          <div className="tab-list">
            <div className="gobal-map">
              <img className="globalmap" src="https://img.chunhomall.com/images/brand_site/map-Malaysia_img_1240x650.jpg.jpg" style={{width:"100%"}} alt=""></img>              
            </div>
            <div className="map-info">
              <img className="map-info-img" src="https://img.chunhomall.com/images/brand_site/map-section-06_400x400.jpg.jpg" alt=""></img>
              <div className="map-info-text">
                <div className="map-info-title">말레이시아</div>
                <div className="map-info-content">2030을 타켓으로 다양한 제품과 할랄, 키즈 제품을 온·오프라인에서 판매하고 있습니다.</div>
              </div>
            </div>
          </div>
          <div className="tab-list">
            <div className="gobal-map">
              <img className="globalmap" src="https://img.chunhomall.com/images/brand_site/map-Singapore_img_1240x650.jpg.jpg" style={{width:"100%"}} alt=""></img>              
            </div>
            <div className="map-info">
              <img className="map-info-img" src="https://img.chunhomall.com/images/brand_site/map-section-07_400x400.jpg.jpg" alt=""></img>
              <div className="map-info-text">
                <div className="map-info-title">싱가폴</div>
                <div className="map-info-content">프리미엄, 하루활력 등 다양한 제품을 온·오프라인에서 만나볼 수 있습니다.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Global;